exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapse[data-v-f503f33c]{height:38px}.collapse[data-v-f503f33c]:hover{font-size:20px}.collapse[data-v-f503f33c]:hover:active{margin-top:2px;margin-left:2px}a[data-v-f503f33c]{background:rgba(0,0,0,.1);color:#597572;text-decoration:none;text-transform:uppercase;border-radius:5px;letter-spacing:1px;display:inline-block;padding:0 2px;padding-top:1px}.expand[data-v-f503f33c]{color:#ff0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-f503f33c&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/collapse.vue
// module id = 96
// module chunks = 0